import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  AlertController,
  LoadingController,
  ModalController,
  PopoverController,
} from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { CompanyService } from "src/app/app/company/company.service";
import { ImagePreviewComponent } from "src/app/app/_component/image-preview/image-preview.component";
import { PopoverButton } from "src/app/app/_component/popover/popover.model";
import { globalHelper } from "src/app/_helpers/global";
import { BookingAction } from "src/app/_models/booking-action.enum";
import { BookingModel, BookingStatus, EditBookingConfig } from "src/app/_models/booking.model";
import { BookingService } from "src/app/_services/booking.service";
import { ConfigService } from "src/app/_services/config.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";
import { ParkingService } from "../../../parking/parking.service";
import { UserAssignmentViewDetailsComponent } from "../user-assignment-view/user-assignment-view-details/user-assignment-view-details.component";
import { SpaceBookingViewChangeUserComponent } from "./space-booking-view-change-user/space-booking-view-change-user";
import { EditBookingComponent } from "src/app/app/booking/edit-booking/edit-booking.component";
import { DictionaryService } from "src/app/dictionary";
import { UserService } from "src/app/_services";

@Component({
  selector: "app-space-booking-view",
  templateUrl: "./space-booking-view.component.html",
  styleUrls: [
    "./space-booking-view.component.scss",
    "./../../../../_styles/ion-grid-content-table.scss",
  ],
})
export class SpaceBookingViewComponent implements OnInit {
  constructor(
    public spaceService: SpaceService,
    public alertController: AlertController,
    private loadingCtrl: LoadingController,
    public translateService: TranslateService,
    public popoverController: PopoverController,
    private bookingService: BookingService,
    private parkingServ: ParkingService,
    private configServ: ConfigService,
    private modalController: ModalController,
    public companyServ: CompanyService,
    public p: ThisPlatform,
    public modalCtrl: ModalController,
    public bookingServ: BookingService,
    public dictionaryServ: DictionaryService,
    private userServ: UserService,
  ) {}

  @Input()
  row: any;

  @Input()
  dateKeySeparator: string;

  @Input()
  displayMobileView = false;

  @Input()
  customData: string;

  @Input()
  styleClass;

  @Input()
  spaceType;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  currentLang = this.translateService.currentLang;
  barriers = [];

  showBarrierButtonForPastBookings: boolean = true;
  onLoadingDisable = false;

  editSpaceLink: string;
  editReservationRole: string;
  deleteReservationRole: string;
  spacePlug: string;
  showBarierrButtonsAndRegistrationNumber: boolean;
  spaceNameLabel: string;
  spaceMessage: string;

  barrierButtonText: string = this.translateService.instant("SPACE.BARRIER");

  bookingError: boolean = false;

  buttonList: PopoverButton[] = [
    {
      name: "SPACE.DETAILS",
      icon: "information-circle",
      eventType: "info",
    },
    {
      name: "EDIT",
      icon: "create-outline",
      eventType: "edit",
    },
    {
      name: "SPACE.SHARE_SPACE_SOMEONE",
      icon: "arrow-redo",
      eventType: "change-user",
    },
    {
      name: "SPACE.FINISH",
      icon: "ban",
      eventType: "finish",
    },
    {
      name: "SPACE.CANCEL",
      icon: "ban",
      eventType: "cancel",
    },
    {
      name: "DELETE",
      icon: "trash",
      eventType: "delete",
    },
  ];

  ngOnInit() {
    switch (this.spaceType) {
      case SpaceType.Parking:
        this.editReservationRole = "parking.my-reservations.edit";
        this.deleteReservationRole = "parking.my-reservations.delete";
        this.spacePlug = "../../../assets/icons/parking-plug.svg";
        this.showBarierrButtonsAndRegistrationNumber = true;
        this.spaceNameLabel = this.translateService.instant("SPACE.PLACE");
        this.spaceMessage = this.translateService.instant("SPACE.PARKING.SHARED_PARKING_PLACE");
        break;
      case SpaceType.Desk:
        this.editReservationRole = "desk.my-reservations.edit";
        this.deleteReservationRole = "desk.my-reservations.delete";
        this.spacePlug = "../../../assets/icons/desk-plug.svg";
        this.showBarierrButtonsAndRegistrationNumber = false;
        this.spaceNameLabel = this.translateService.instant("SPACE.DESK.DESK");
        this.spaceMessage = this.translateService.instant("SPACE.DESK.SHARED_DESK");
        break;
      case SpaceType.Room:
        this.spacePlug = "../../../assets/icons/room-plug.svg";
        this.showBarierrButtonsAndRegistrationNumber = false;
        this.spaceNameLabel = this.translateService.instant("BOOKING.ROOM");
        this.spaceMessage = this.translateService.instant("SPACE.ROOM.SHARED_ROOM");
        break;
    }

    if (this.configServ.configs.length > 0) {
      this.loadBarriers();
    } else {
      this.configServ.loadConfigs().then((v) => {
        this.loadBarriers();
      });
    }

    this.setButtonDisplay();

  }

  loadBarriers() {
    this.barriers = this.configServ.configs.filter((s) =>
      s.key.includes("parking_barrier")
    );
  }

  avilableToOpenExitBarierr(item){
    if(item.key.includes('exit') && (this.row.startTime > new Date(Date.now()).toISOString()) && (this.row.status != 'registredDeparture')){
      return true;
    } else {
      return false;
    }
  }

  async onShowPopover(event: Event) {
    let popoverInfo: string;

    if (
      (this.row.status == "registredEntry" || this.row.status == "registredDeparture") && 
      (new Date(Date.now()).toISOString() >= this.row.startTime)
    ) {
      popoverInfo = "SPACE.PARKING.BARIERR_OPENED";
    } else if(
      (this.row.startTime > new Date(Date.now()).toISOString()) && (this.row.status != 'registredDeparture')
    ){
      popoverInfo = "SPACE.PARKING.OPEN_BARRIER_EXIT_ERROR";
    } else if(
      (this.row.status == 'canceled' || this.row.status == 'ended')
    ){
      popoverInfo = "SPACE.PARKING.PARKING_ENDED";
    } else {
      popoverInfo = "SPACE.PARKING.BLOCKED_BARIERR_WARNING";
    }
    const popover = await globalHelper.Popover(
      this.popoverController,
      event,
      [],
      "user-assignment-view-share__popover",
      popoverInfo
    );
  }

  async presentPopover(ev: any) {
    this.bookingService.booking = this.row;

    let popover = await globalHelper.Popover(
      this.popoverController,
      ev,
      this.buttonList,
      "user-assignment-view-share__popover"
    );
    if (popover) {
      if (popover.data === "change-user") {
        this.editReservationOwner(this.row.id);
      } else if (popover.data === "delete") {
        this.deleteReservation(this.row.id);
      } else if (popover.data === "finish") {
        this.finishReservation(this.row, BookingAction.endBooking);
      } else if (popover.data === "info") {
        this.showReservationDetails(this.row);
      } else if (popover.data === "edit") {
        this.editReservation(this.row.id)
      } else if (popover.data === "cancel") {
        console.log("cancel")
        this.finishReservation(this.row, BookingAction.userCancelBooking);
      };
    }
  }

  async editReservationOwner(reservationId) {
    const modal = await this.modalController.create({
      component: SpaceBookingViewChangeUserComponent,
      componentProps: {
        id: reservationId,
        assignmentDetails: this.row,
        spaceType: this.spaceType
      },
      animated: true,
      cssClass: "add-edit-modal add-edit-modal--edit-parking-space",
    });

    modal.present();
    modal.onDidDismiss().then(async (data) => {
      const userPassMessage = this.bookingServ.booking.userOwner.firstName + " " + this.bookingServ.booking.userOwner.lastName;
      if (data.data === "update") {

        const alert = await this.alertController.create({
          header: this.translateService.instant("CONFIRM"),
          message: this.spaceMessage + userPassMessage,
          buttons: ["OK"],
        });
        await alert.present();

        this.actionRequest.emit("refresh");
      }
    });
  }

  async deleteReservation(reservationId) {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );
    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateService.instant("DELETING"),
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.bookingService
            .deleteBooking(Number(reservationId))
            .subscribe(() => {
              loadingEl.dismiss();
              this.actionRequest.emit("refresh");
            });
        });
    }
  }

  async showReservationDetails(data) {
    const modal = await this.modalController.create({
      component: UserAssignmentViewDetailsComponent,
      animated: true,
      cssClass: "add-edit-modal add-edit-modal--small",
      componentProps: {
        row: data,
        type: "booking",
      },
    });
    modal.present();
  }

  async finishReservation(reservation: BookingModel, action: BookingAction) {
    const confirmation = action === BookingAction.endBooking ? "SPACE.FINISH_CONFIRMATION" : "SPACE.CANCEL_CONFIRMATION";
    const message = action === BookingAction.endBooking ? "SPACE.FINISHING" : "SPACE.CANCELING";

    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService,
      this.translateService.instant(confirmation)
    );
    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateService.instant(message),
        })
        .then((loadingEl) => {
          loadingEl.present();

          this.bookingService.patchBooking(
            reservation, 
            action
          ).subscribe(() => {
            loadingEl.dismiss();
            this.actionRequest.emit("refresh");
          });
        });
    }
  }

  exitButtonText(item) {
    if (item.key.includes("exit")) {
      return this.translateService.instant("SPACE.PARKING.OPEN_BARRIER_EXIT");
    } else {
      return this.translateService.instant("SPACE.PARKING.OPEN_BARRIER_ENTER");
    }
  }

  openBarrier(item) {
    if (
      item.key.includes("exit") &&
      new Date(this.row.endTime).getTime() > new Date().getTime()
    ) {
      this.shareSpaceWhenLeavingParking();
    } else if (
      item.key.includes("exit") &&
      new Date(this.row.endTime).getTime() <= new Date().getTime()
    ) { 
      this.leavingParking();
    }
    else {
      this.enteringParking();
    }
  }

  openingDisable() {
    this.onLoadingDisable = true;
    this.barrierButtonText = this.translateService.instant(
      "SPACE.PARKING.OPENING_BARRIER"
    );
    setTimeout(() => {
      this.onLoadingDisable = false;
    }, 5000);
  }

  async onQRCodePreview($event, qrCode) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalController.create({
      component: ImagePreviewComponent,
      componentProps: { qrCode: qrCode },
      animated: true,
      cssClass: "image-preview-present",
    });
    modal.present();
  }

  async shareSpaceWhenLeavingParking() {
    this.bookingService
      .patchBooking(this.row, BookingAction.parkingDeparture)
      .subscribe({
        next: () => {},
        error: () => { 
          this.barrierOpenError();
          this.bookingError = true; 
        },
        complete: () => {
          if (!this.bookingError) {
            this.loadingCtrl
            .create({
              keyboardClose: true,
              message: this.translateService.instant("SPACE.FINISHING"),
            })
            .then((loadingEl) => {
              this.openingDisable();
              loadingEl.present();
      
              this.row.endTime = new Date().toISOString();
      
              this.bookingService.updateBooking(this.row).subscribe(() => {
                loadingEl.dismiss();
                this.actionRequest.emit("refresh");
              });
            });
          }
        } 
      });
  }

  async enteringParking() {
    this.bookingService
      .patchBooking(this.row, BookingAction.parkingEntry)
      .subscribe({
        next: () => {
          this.actionRequest.emit("refresh");
        },
        error: () => {
          this.barrierOpenError();
        }
      });
    this.openingDisable();
  }

  async leavingParking() {
    this.bookingService
      .patchBooking(this.row, BookingAction.parkingDeparture)
      .subscribe({
        next: () => {
          this.actionRequest.emit("refresh");
        },
        error: () => {
          this.barrierOpenError();
        }
      });
    this.openingDisable();
  }

  async barrierOpenError() {
    const alert = await this.alertController.create({
      header: this.translateService.instant("SPACE.PARKING.PARKING_CANCELED"),
      message: this.translateService.instant("SPACE.ERROR.BARRIER_ERROR"),
      buttons: ["OK"],
    });
    (await alert).present()
    alert.onDidDismiss().then(()=> {
      this.actionRequest.emit("refresh")
    })
  }

  // translateValue(value: string): string {
  //   let char = value.indexOf("_");
  //   let name = this.translate.instant(value.substr(0, char));
  //   return name + " " + value.substr(char + 1);
  // } TODO: Funkcja zwraca tłumaczenie konkretnego szlabanu. Na razie tłumaczenie dajemy z ogólnego słownika, zgodnie z projektem.

  async editReservation(id: number) {

    const config: EditBookingConfig = {
      header: "BOOKING.DETAILS",
      spaceLabel: this.spaceNameLabel,
      actionButtonsDisplay: false,
      statusDisplay: false,
      listDisplay: false,
      dateChange: false,
      topicChange: false,
    };

    this.bookingServ.getBooking(id).subscribe(
      (booking: BookingModel) => {
        this.bookingServ.booking = booking;
      },
      (e) => { },
      async () => {
        const modal = await this.modalController.create({
          component: EditBookingComponent,
          animated: true,
          cssClass: "add-edit-modal",
          componentProps: {
            type: this.spaceType,
            config: config
          },
        });
        modal.present();

        await modal.onWillDismiss().then(() => {
          this.actionRequest.emit("refresh");
        });
      });
  }

  private async setButtonDisplay() {
    if (
      new Date().getTime() - 1800000 > new Date(this.row.endTime).getTime() ||
      new Date().getTime() + 1800000 < new Date(this.row.startTime).getTime()
    ) {
      this.showBarrierButtonForPastBookings = false;
    }

    if (new Date().getTime() > new Date(this.row.endTime).getTime()) {
      this.buttonList.splice(1, 2);
    }

    if(new Date().getTime() < new Date(this.row.startTime).getTime()) {
      this.buttonList = this.buttonList.filter((b) => b.eventType !== "finish");
    } else {
      this.buttonList = this.buttonList.filter((b) => b.eventType !== "cancel");
    }

    if (
      this.row.status == BookingStatus.RegistredDeparture ||
      this.row.status == BookingStatus.Ended ||
      this.row.status == BookingStatus.Canceled || 
      this.row.status == BookingStatus.CanceledByUser
    ) {
      this.buttonList = this.buttonList.filter((b) => b.eventType !== "finish");
    }

    if (
      this.row.status == BookingStatus.Ended ||
      this.row.status == BookingStatus.Canceled || 
      this.row.status == BookingStatus.CanceledByUser
    ) {
      this.buttonList = this.buttonList.filter((b) => b.eventType !== "cancel");
    }

    if(!(await this.userServ.hasRolesAsync([this.deleteReservationRole]))) {
      this.buttonList = this.buttonList.filter((b) => b.eventType !== "delete");
    }
  }
}
